import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import isEqual from 'lodash/isEqual';
import isNull from 'lodash/isNull';
import { Button } from 'react-bootstrap';
import { thunks } from '@redux/jobs';

class Title extends Component {
	shouldComponentUpdate = ({ filter }) => {
		const lastProps = this.props;

		return (
			!isEqual(filter, lastProps.filter)
		);
	};

	clearRecurrence = () => {
		const { applyCriteria } = this.props;

		applyCriteria([{ property : 'recurrenceId', value : null }]);
	}

	render() {
		const { filter : { recurrenceId } } = this.props;

		return (
			<div className="container margin-top-30 flex flex-align-items-center">
				<div className="flex-auto font-size-30">
					<span>Jobs</span>
					<If condition={!isNull(recurrenceId)}>
						<span className="font-light margin-left-5">/</span>
						<Button
							bsSize="xsmall"
							className="font-light margin-left-10"
							onClick={this.clearRecurrence}
						>
							Recurrence
							{' '}
							{ recurrenceId }
							<i className="fa fa-times margin-left-sm" />
						</Button>
					</If>
				</div>
			</div>
		);
	}
}

const mapStateToProps = ({
	jobs : { filter : { recurrenceId } },
}) => ({
	filter : { recurrenceId },
});

const mapDispatchToProps = (dispatch) => ({
	applyCriteria : bindActionCreators(thunks, dispatch).applyCriteria,
});

Title.propTypes = {
	applyCriteria : PropTypes.func.isRequired,
	filter        : PropTypes.object,
};

Title.defaultProps = {
	filter : {},
};

export default connect(mapStateToProps, mapDispatchToProps)(Title);
